/**
 * Labstep
 *
 * @module components/Tag/SearchSelect
 * @desc Search tags
 */

import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import { Tag } from 'labstep-web/models/tag.model';
import type React from 'react';
import type { ITagSearchSelectProps } from './types';

export const TagSearchSelect: React.FC<ITagSearchSelectProps> = ({
  onChange,
  ...rest
}) => (
  <SearchSelect
    entityName={Tag.entityName}
    creatable
    onChange={(tag) => onChange(tag)}
    value={null}
    {...rest}
    usePartialSerializer
  />
);
